import { createFileRoute } from "@tanstack/react-router";
import {
    emailPreferencesRouteOptions,
    EmailPreferencesRoute,
} from "@/features/viewer-profile";

export const Route = createFileRoute("/settings/email")({
    ssr: emailPreferencesRouteOptions.ssr,
    loader: emailPreferencesRouteOptions.loader,
    head: emailPreferencesRouteOptions.head,
    component: EmailPreferencesRoute,
});
